import script from "./StrategyDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./StrategyDetails.vue?vue&type=script&setup=true&lang=ts"

import "./StrategyDetails.vue?vue&type=style&index=0&id=c41cd138&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c41cd138"]])

export default __exports__